import { View, Text, StyleSheet, Modal } from "react-native";
import React, { useState, useEffect } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useStateContext } from "../lib/context";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigation } from "@react-navigation/native";
import {
  ScrollView,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ActivityIndicator,
} from "react-native-web";

const Cart = () => {
  const [display, setDisplay] = useState(false);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);

  const navigation = useNavigation();

  const {
    cartItems,
    totalQty,
    onRemove,
    currentUser,
    setCartItems,
    promoEro,
    promoDrn,
    setScroll,
    onPlus,
    onMinus,
  } = useStateContext();

  const promoIdDrn = promoDrn;
  const promoIdEro = promoEro;

  const promoMatrix = [
    { not: "not" },
    { uno: 30, tres:  0, nueve: 0, dos: 10 },
    { uno: 30, tres: 30, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 25, tres: 25, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 32, tres: 36, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos: 10 },
    { uno: 34, tres: 38, nueve: 0, dos: 20 },
    { uno: 32, tres: 33, nueve: 0, dos: 10 },
    { uno: 34, tres: 34, nueve: 0, dos:  0 },
    { uno: 20, tres: 20, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 32, tres: 30, nueve: 0, dos: 10 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 15 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 30, nueve: 0, dos:  0 },
    { uno: 40, tres: 30, nueve: 0, dos: 10 },
  ];

  // Calculate Total without discount
  useEffect(() => {
    const newTotal = cartItems.reduce((sum, item) => {
      return sum + Number(item.price) * Number(item.quantity);
    }, 0);
    setTotal(newTotal);
  }, [cartItems]);

  useEffect(() => {
    setScroll(!display);
  }, [display]);

  // Calculate Discount
  useEffect(() => {
    if (!promoIdEro || !promoIdDrn) return;
    const newTotal = cartItems.reduce((sum, item) => {
      const chu =
        item.type == "1"
          ? promoMatrix[promoIdEro].uno
          : item.type == "2"
          ? promoMatrix[promoIdDrn].dos
          : item.type == "3"
          ? promoMatrix[promoIdEro].tres
          : promoMatrix[promoIdEro].nueve;
      const temp = ((parseInt(chu) * item.price) / 100).toFixed(2);
      return sum + Number(temp) * Number(item.quantity);
    }, 0);
    setDiscount(newTotal);
  }, [cartItems, promoIdEro, promoIdDrn]);

  return (
    <>
      <View style={{ position: 'relative' }}>
        <TouchableOpacity onPress={() => setDisplay(true)} style={localStyles.cartIconContainer}>
          <Ionicons name="cart-outline" size={32} color="white" />
          {totalQty > 0 && (
            <View style={localStyles.badge}>
              <Text style={localStyles.badgeText}>{totalQty}</Text>
            </View>
          )}
        </TouchableOpacity>
      </View>

      <Modal
        visible={display}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setDisplay(false)}
      >
        <View style={localStyles.overlayContainer}>
          {/* Backdrop */}
          <TouchableWithoutFeedback onPress={() => setDisplay(false)}>
            <View style={localStyles.backdrop} />
          </TouchableWithoutFeedback>

          {/* Drawer */}
          <View style={localStyles.drawer}>
            <View style={localStyles.drawerHeader}>
              <Text style={localStyles.drawerTitle}>Tu Pedido ({totalQty})</Text>
              <TouchableOpacity onPress={() => setDisplay(false)} style={localStyles.closeButton}>
                <Ionicons name="close" size={24} color="#333" />
              </TouchableOpacity>
            </View>

            <ScrollView style={localStyles.itemsList} contentContainerStyle={{ padding: 20 }}>
              {cartItems.length > 0 ? (
                cartItems.map((item, index) => {
                  const chu =
                    item.type == "1"
                      ? promoMatrix[promoIdEro]?.uno || 0
                      : item.type == "2"
                      ? promoMatrix[promoIdDrn]?.dos || 0
                      : item.type == "3"
                      ? promoMatrix[promoIdEro]?.tres || 0
                      : promoMatrix[promoIdEro]?.nueve || 0;
                  
                  const price = Number(item.price);
                  const discontinuedPrice = price - (parseInt(chu) * price) / 100;
                  const itemTotal = discontinuedPrice * item.quantity;

                  return (
                    <View key={index} style={localStyles.cartItem}>
                      <View style={localStyles.itemHeader}>
                        <View style={{flex: 1}}>
                          <Text style={localStyles.itemName}>{item.name}</Text>
                          <Text style={localStyles.itemSku}>SKU: {item.sku}</Text>
                        </View>
                        <TouchableOpacity onPress={() => onRemove(item)} style={localStyles.deleteButton}>
                          <Ionicons name="trash-outline" size={22} color="#ff4444" />
                        </TouchableOpacity>
                      </View>

                      <View style={localStyles.itemFooter}>
                        {/* Price Section */}
                        <View style={localStyles.priceContainer}>
                          {chu > 0 ? (
                            <View>
                              <View style={{flexDirection: 'row', alignItems: 'center', gap: 6}}>
                                <Text style={localStyles.strikethrough}>${price.toFixed(2)}</Text>
                                <View style={localStyles.discountBadge}>
                                  <Text style={localStyles.discountText}>-{chu}%</Text>
                                </View>
                              </View>
                              <Text style={localStyles.finalPrice}>${discontinuedPrice.toFixed(2)}</Text>
                            </View>
                          ) : (
                            <Text style={localStyles.finalPrice}>${price.toFixed(2)}</Text>
                          )}
                          <Text style={localStyles.itemTotalLabel}>
                            Subtotal: <Text style={localStyles.itemTotalValue}>${itemTotal.toFixed(2)}</Text>
                          </Text>
                        </View>

                        {/* Quantity Controls */}
                        <View style={localStyles.quantityControl}>
                          <TouchableOpacity onPress={() => onMinus(index)} style={localStyles.qtyButton}>
                            <Ionicons name="remove" size={20} color="#2a2a8e" />
                          </TouchableOpacity>
                          <Text style={localStyles.qtyText}>{item.quantity}</Text>
                          <TouchableOpacity onPress={() => onPlus(index)} style={localStyles.qtyButton}>
                            <Ionicons name="add" size={20} color="#2a2a8e" />
                          </TouchableOpacity>
                        </View>
                      </View>
                    </View>
                  );
                })
              ) : (
                <View style={localStyles.emptyCart}>
                  <Ionicons name="cart-outline" size={64} color="#ddd" />
                  <Text style={localStyles.emptyText}>Tu carrito está vacío</Text>
                  <TouchableOpacity onPress={() => setDisplay(false)} style={localStyles.continueButton}>
                    <Text style={localStyles.continueButtonText}>Ir al Catálogo</Text>
                  </TouchableOpacity>
                </View>
              )}
            </ScrollView>

            {cartItems.length > 0 && (
              <View style={localStyles.footer}>
                <View style={localStyles.summaryRow}>
                  <Text style={localStyles.summaryLabel}>Subtotal</Text>
                  <Text style={localStyles.summaryValue}>${total.toFixed(2)}</Text>
                </View>
                {discount > 0 && (
                  <View style={localStyles.summaryRow}>
                    <Text style={localStyles.discountLabel}>Tu Descuento</Text>
                    <Text style={localStyles.discountValue}>- ${discount.toFixed(2)}</Text>
                  </View>
                )}
                <View style={[localStyles.summaryRow, localStyles.totalRow]}>
                  <Text style={localStyles.totalLabel}>Total Final (+IVA)</Text>
                  <Text style={localStyles.totalValue}>${(total - discount).toFixed(2)}</Text>
                </View>

                <TouchableOpacity 
                  style={localStyles.checkoutButton}
                  onPress={() => {
                    setDisplay(false);
                    navigation.navigate("Checkout");
                  }}
                >
                  <Text style={localStyles.checkoutButtonText}>Realizar Pedido</Text>
                  <Ionicons name="arrow-forward" size={20} color="#fff" />
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      </Modal>
    </>
  );
};

const localStyles = StyleSheet.create({
  cartIconContainer: {
    padding: 8,
  },
  badge: {
    position: "absolute",
    top: 4,
    right: 4,
    backgroundColor: "#ff4444",
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 4,
  },
  badgeText: {
    color: "#fff",
    fontSize: 10,
    fontWeight: "bold",
  },
  overlayContainer: {
    flex: 1,
    flexDirection: "row",
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: 'flex-end',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  drawer: {
    width: "85%",
    maxWidth: 400,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: { width: -2, height: 0 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  drawerHeader: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    paddingTop: 50,
  },
  drawerTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#333",
  },
  closeButton: {
    padding: 4,
  },
  itemsList: {
    flex: 1,
    backgroundColor: "#F8F9FA",
  },
  cartItem: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
  },
  itemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  itemName: {
    fontSize: 15,
    fontWeight: "600",
    color: "#333",
    marginBottom: 2,
  },
  itemSku: {
    fontSize: 12,
    color: "#999",
  },
  deleteButton: {
    padding: 4,
  },
  itemFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  priceContainer: {
    flex: 1,
  },
  strikethrough: {
    fontSize: 12,
    color: "#999",
    textDecorationLine: "line-through",
  },
  discountBadge: {
    backgroundColor: "#ffebee",
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  discountText: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#ff4444",
  },
  finalPrice: {
    fontSize: 16,
    fontWeight: "700",
    color: "#2a2a8e",
    marginVertical: 2,
  },
  itemTotalLabel: {
    fontSize: 12,
    color: "#666",
    marginTop: 4,
  },
  itemTotalValue: {
    fontWeight: "bold",
    color: "#333",
  },
  quantityControl: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F4F6FD",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E0E0E0",
  },
  qtyButton: {
    width: 32,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 7,
    margin: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
    elevation: 1,
  },
  qtyText: {
    marginHorizontal: 12,
    fontSize: 15,
    fontWeight: "600",
    color: "#333",
    minWidth: 20,
    textAlign: 'center',
  },
  footer: {
    padding: 24,
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderTopColor: "#eee",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 10,
    paddingBottom: 40,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  summaryLabel: {
    fontSize: 14,
    color: "#666",
  },
  summaryValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  discountLabel: {
    fontSize: 14,
    color: "#4CAF50",
    fontWeight: "500",
  },
  discountValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#4CAF50",
  },
  totalRow: {
    marginTop: 8,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  totalValue: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
  checkoutButton: {
    backgroundColor: "#2a2a8e",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    borderRadius: 12,
    marginTop: 16,
    gap: 8,
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  checkoutButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
  emptyCart: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 60,
  },
  emptyText: {
    fontSize: 18,
    color: "#999",
    marginTop: 16,
    marginBottom: 24,
  },
  continueButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderWidth: 1,
    borderColor: "#2a2a8e",
    borderRadius: 8,
  },
  continueButtonText: {
    color: "#2a2a8e",
    fontSize: 15,
    fontWeight: "600",
  },
});

export default Cart;
